<template>
  <div
    :id="title_component"
    :collapsed="collapsed"
    :uuid="uuid"
    v-show="id_selected ? id_selected == is_selected : true"
    badge="graph"
    colorBadge="info"
    style="width: 100%; height: 100%"
  >
    <div slot="default" class="">
      <!-- global container for svg graph -->
      <div v-if="spinner" class="block_parent_spinner">
        <div class="block_spinner">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>

          <p style="color: #068bea; position: absolute; left: 45%; top: 65%">
            data are being collected ...
          </p>
        </div>
      </div>

      <div
        @mouseleave="deleteTooltip"
        @mousemove="createTooltip"
        ref="canvas"
        class="block_graph"
        style="width: 100%; height: 100%"
      ></div>
      <!-- legend -->
      <div class="card-footer row col-sm ml-0">
        <!-- legend items (one per flux) -->
        <div
          v-for="f in definitions"
          class="graphic"
          :class="f.attributes.name"
          :key="f.attributes.name"
          :style="`color:${f.attributes.color}`"
          style="display: flex; cursor: pointer"
          @click="toggleVisibility(f.attributes.name)"
        >
          <!-- box -->
          <p
            :style="`color:${
              f.attributes.visible || f.attributes.visible == undefined
                ? 'transparent'
                : f.attributes.color
            };text-shadow: 0 0 0 ${f.attributes.color};`"
            class="mr-2"
          >
            {{
              f.attributes.visible || f.attributes.visible == undefined
                ? "&#11035;"
                : "&#11036;"
            }}
          </p>
          <vue-mathjax
            v-if="f.attributes.label_mathjax"
            :formula="f.attributes.label_mathjax"
          ></vue-mathjax>
          <!-- Name -->
          {{ f.attributes.label ? f.attributes.label : f.attributes.name }}
          {{
            f.attributes.model
              ? `${$store.getters.testParams[f.attributes.model]}`
              : ""
          }}
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://d3js.org/d3.v4.js"></script>
<script>
import dataD3GraphComponentMixin from "ireal-vue/mixins/data-d3-graph-component-mixin.js";
import dataD3SpinnerComponentMixin from "ireal-vue/mixins/data-d3-spinner-component-mixin.js";
import tooltipD3ComponentMixin from "ireal-vue/mixins/tooltip-interpolate-d3-component-mixin.js";
import CollapsibleWidget from "ireal-vue/widgets/CollapsibleWidget.vue";
import * as d3 from "d3";
import httpService from "../services/http-service";
import Bus from "../services/bus.js";
import { VueMathjax } from "vue-mathjax";

export default {
  name: "histogram-component",
  mixins: [
    dataD3GraphComponentMixin,
    tooltipD3ComponentMixin,
    dataD3SpinnerComponentMixin,
  ],
  components: { CollapsibleWidget, "vue-mathjax": VueMathjax },
  data() {
    return {
      is_selected: null,
      indice_in_progress: "",
      spinner: false,
    };
  },
  async created() {
    // we use httpMixin. request to have the list of experience. Fill array "experience" with results.
    this.definitions = this.config.elements;
    Bus.$on("selected-changed", async (payload) => {
      this.is_selected = `${
        this.$store.getters.listSelected[this.model_selected]
      }`;
    });
    Bus.$on("ireal-stop", async (payload) => {
      this.spinner = false;
    });
    this.local_config.elements.forEach((element) => {
      element.attributes.visible = true;
    });
  },
  methods: {
    getVisibility(flux_name) {
      var visibility = 0;
      this.local_config.elements.forEach((element) => {
        if (element.attributes.name === flux_name) {
          visibility = element.attributes.visible;
        }
      });
      // au depart , visibility est à undefined donc diff de false
      if (visibility !== false) visibility = true;
      return visibility;
    },
    applyVisibility(flux_name) {
      this.dom_canvas
        .selectAll(`.${flux_name}`)
        .style("opacity", this.getVisibility(flux_name) ? 1 : 0);
    },
    setVisibility(flux_name, visibility) {
      var newconfig = Object.assign(this.local_config);
      newconfig.elements.forEach((element) => {
        if (element.attributes.name === flux_name)
          element.attributes.visible = visibility;
      });
      this.local_config = newconfig;
      this.applyVisibility(flux_name);
      this.$forceUpdate();
    },
    toggleVisibility(flux_name) {
      this.setVisibility(flux_name, !this.getVisibility(flux_name));
    },
    prepareFlux(flux_structure) {
      // Includes into the DOM the d3path: The DOM Object that represents the line
      // The path is stored in the "d" attribute of d3path
      // After the execution of this function the path id empty
      if (typeof flux_structure.d3path === "undefined") {
        // Value line is a function that transforms a dataseries into draw coordinates
        flux_structure.valueline = d3
          .line()
          .x((d) => {
            var abscisse;
            if (!this.Is_data_abscisse) {
              abscisse = JSON.parse(d.time) != 0 ? JSON.parse(d.time) : 1;
            } else {
              abscisse = JSON.parse(d.raw_value)[this.Is_data_abscisse];
            }
            return this.d3_xRange(abscisse);
          })
          .y((d) => {
            var ordonnee;
            ordonnee = flux_structure.yAxis.d3_yRange(
              JSON.parse(d.number_value)
            );
            return ordonnee;
          });

        // Add a path component into the DOM
        // take the attributes color of flux_structure for the line color
        // take the attributes clipAreaURL of flux_structure for the line clip area (cf. data-d3-component-mixin.js)

        flux_structure.dom_path = this.dom_canvas

          .append("path")
          .attr(
            "style",
            "fill: none;stroke-linecap:round;stroke-linejoin:round"
          )
          .attr("class", `${flux_structure.name}`)
          .attr("stroke", flux_structure.attributes.color)
          .attr(
            "stroke-width",
            this.attributes.line_weight ? this.attributes.line_weight : "1px"
          )
          .attr("stroke-dasharray", flux_structure.attributes.dash)
          .attr("clip-path", this.clipAreaURL);

        // for add dot for each data
        this.dom_canvas
          .append("circle")
          .attr("class", `${flux_structure.name}`)
          .attr("fill", flux_structure.attributes.color)
          .attr("opacity", 0.5)
          .attr("clip-path", this.clipAreaURL);

        this.applyVisibility(flux_structure.name);
      }
    },
    prepare() {
      this.D3GraphPrepare();
    },
    tickFlux(flux_structure) {
      if (
        !flux_structure.attributes.time_display ||
        (this.$store.getters.progress / this.$store.getters.duration) * 100 >
          flux_structure.attributes.time_display
      ) {
        this.spinner = false;
        // Updates the DOM for a given flux (rendering)
        if (flux_structure.dom_path != undefined) {
          var data_on_progress = [];
          for (var i in flux_structure.data) {
            data_on_progress.push(flux_structure.data[i]);

            if (
              flux_structure.data[i]["time"] >
              this.$store.getters.progress + this.timeStart + 1001
            ) {
              break;
            }
            this.indice_in_progress = JSON.parse(
              data_on_progress[data_on_progress.length - 1].raw_value
            )["indice"];
          }
          flux_structure.dom_path.attr(
            "d",
            flux_structure.valueline(data_on_progress)
          );

          if (
            (this.$store.getters.progress > 1000) & this.Is_histogram_plot ||
            this.Is_histogram_plot == 0
          ) {
            this.dom_canvas
              .selectAll(`.circle${flux_structure.attributes.name}`)
              .remove();
            this.dom_canvas
              .selectAll(".dot")
              .data(data_on_progress)
              .enter()
              .append("circle")
              .attr("class", `circle${flux_structure.attributes.name}`)
              .attr("fill", flux_structure.attributes.color)
              .attr("opacity", 0.5)
              .attr("r", `${this.config.attributes.plot}`)
              .attr("cx", (d) => {
                return this.d3_xRange(
                  JSON.parse(d.raw_value)[this.Is_data_abscisse]
                );
              })
              .attr("cy", (d) => {
                return flux_structure.yAxis.d3_yRange(d.number_value);
              });
          }
        }
      }
    },
    tick() {
      this.D3GraphTick();
    },

    //TODO: passer sur tous les flux definition et prendre le max
    componentStartEvent() {
      this.spinner = true;
      const params = {
        params: this.$store.getters.testParams,
        flux_identifier: this.attributes.flux_pilot
          ? this.attributes.flux_pilot
          : this.flux_identifier,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      this.getTimeData(params);

      // retourne toutes les promesses, lorsqu'elles sont toutes résolues. Sinon, le mounted subira une erreur au niveau du then
    },
  },
};
</script>
<style scoped>
.graphic {
  font-size: 12px;
  padding-left: 1em;
}
.md-progress-spinner-circle svg {
  stroke: blue !important;
}
.block_graph {
  position: relative;
  width: 100%;
  height: 100%;
}
.block_parent_spinner {
  position: absolute;
  width: 100%;
  height: 100%;
}
.block_spinner {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lds-ring {
  display: inline-block;
  position: absolute;
  width: 80px;
  height: 80px;
  left: 45%;
  top: 50%;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #068bea;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #068bea transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
